export default {
  common__validation__is_required: 'El campo es obligatorio',
  common__validation__invalid_format: 'Valor incorrecto',
  common__validation__invalid_file_size: 'El tamaño del archivo excede el límite máximo ({size})',
};
